export default __webpack_public_path__ + "static/media/s1.511b0a89.png";